import { AuthorizationParams } from "@auth0/auth0-react";

export const messages: Record<
  string,
  (error: Error) => {
    isError: boolean;
    title: string;
    message: string;
    prompt: AuthorizationParams["prompt"];
    cta: string;
  }
> = {
  verifyEmail: (error: Error) => ({
    isError: error.message.toLocaleLowerCase().includes("verify your email"),
    title: "Email has been sent",
    message: "Check your email to verify your account before signing in.",
    cta: "Sign in",
    prompt: "login",
  }),
  passwordExpired: (error: Error) => ({
    isError: error.message.toLocaleLowerCase().includes("password has expired"),
    title: "Your password has expired",
    message:
      "To reset your password proceed to the login screen, enter you email, click 'Continue', then click 'Forgot Password'.",
    cta: "Log in",
    prompt: "login",
  }),
  invalidState: (error: Error) => ({
    isError: error.message.toLocaleLowerCase().includes("invalid state"),
    title: "Something went wrong",
    message: "Sign in again to access decodable",
    cta: "Sign in",
    prompt: "login",
  }),
} as const;
